export const currencyFormatter = (value: number) => {
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD"
  });

  return formatter.format(value);
};

export const snakeToWords = (text: string) => text.replace(/_/g, " ");
